(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("@feature-hub/react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components", "@feature-hub/react", "react-dom"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("styled-components"), require("@feature-hub/react"), require("react-dom")) : factory(root["react"], root["styled-components"], root["@feature-hub/react"], root["react-dom"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__155__, __WEBPACK_EXTERNAL_MODULE__694__, __WEBPACK_EXTERNAL_MODULE__544__, __WEBPACK_EXTERNAL_MODULE__514__) => {
return 